import Vue from 'vue';
import Vuex from 'vuex';

import VueScrollTo from 'vue-scrollto';
import PortalVue from 'portal-vue';

import UI from '@dui/full-ui';
import '../styles/application.scss';
import '../styles/public-app.scss';

import Device from '@d-shared/utils/device';
import sharedPlugins from '@d-shared/plugins';

import components from './components';
import storeModules from './store';

export default function() {
  if (Device.isiOS()) {
    document.body.classList.add('ios-device');
  }

  Vue.use(Vuex);
  UI.installInVueInstance();

  sharedPlugins.forEach((plugin) => {
    Vue.use(plugin);
  });

  Vue.use(VueScrollTo);
  Vue.use(PortalVue);

  const store = new Vuex.Store({
    modules: storeModules,
  });

  const app = new Vue({
    el: '#discovery-app',
    store: store,
    components: components,
  });
};
